import api from "../../services/api-service"
import { AxiosRequestConfig } from "axios"
import { IContextOptionResponse } from "../interfaces/context-options-response"
import { makeContextOptionsApiRoutes } from "../api/endpoints"

const contextOptionsApiRoutes = makeContextOptionsApiRoutes()

export const fetchContextOptions = (orgId: string, config: AxiosRequestConfig = {}) => {
  return api.get<IContextOptionResponse[]>(contextOptionsApiRoutes.contextOptions(orgId), config)
}
